/* eslint-disable */
// @ts-nocheck

import { ReactNode, useState } from 'react'

import ButtonLoading from '@/components/misc/Button'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'
import { DialogFooter } from '@/components/ui/dialog'
import { Form } from '@/components/ui/form'

import { Modal, ModalProps } from '../Modal'
import { StepsComponent } from '../StepsComponent'
import { useModalWizardStepsContext } from './ModalWizardStepsContext'

interface IStep {
  name: string
  actionButtons: {
    label: string
    secondaryAction?: () => void
    primaryAction?: (data: any) => void
  }[]
  component: ReactNode
}

interface IModalWizzardStepsProps extends Omit<ModalProps, 'footer'> {
  title?: string
  subtitle?: string
  currentStep: number
  isOpen: boolean
  onClose: Function
  steps: IStep[]
  size?: 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl'
  modalClassName?: string
  isSending: boolean
  confirmOnClose?: boolean
}

export function ModalWizardSteps({
  currentStep,
  steps,
  isOpen,
  onClose,
  title,
  subtitle,
  size,
  modalClassName,
  isSending,
  confirmOnClose = false,
}: IModalWizzardStepsProps) {
  const { useFormWizzard } = useModalWizardStepsContext()
  return (
    <Modal
      confirmOnClose={confirmOnClose}
      isOpen={isOpen}
      modalClassName={modalClassName}
      onClose={onClose}
      size={size}
      subtitle={subtitle}
      title={title}
    >
      <StepsComponent
        currentStep={currentStep}
        steps={steps.map((item) => item.name)}
      />
      <Form {...useFormWizzard}>
        <div className={'flex flex-col overflow-y-scroll px-2 scrollbar-thin'}>
          {steps[currentStep].component}
        </div>
        <DialogFooter className="flex-shrink-0 flex-col-reverse gap-2 border-t px-4 pt-4 sm:flex-row sm:justify-between sm:px-6">
          <Footer
            isSending={isSending}
            onClose={onClose}
            step={steps[currentStep]}
          />
        </DialogFooter>
      </Form>
      {/* Eliminada la confirmación de cancelación */}
    </Modal>
  )
}

interface IFooterProps {
  step: IStep
  onClose: Function
  isSending: boolean
}

function Footer({ step, onClose, isSending }: IFooterProps) {
  const { useFormWizzard } = useModalWizardStepsContext()
  const { handleSubmit } = useFormWizzard

  return (
    <>
      <div>
        <Button
          disabled={isSending}
          onClick={() => onClose(false)}
          variant="outline"
        >
          Cancelar
        </Button>
      </div>
      <div className={'flex gap-2'}>
        {step.actionButtons.map((btn, index) =>
          isSending && index === 1 ? (
            <ButtonLoading
              key={`loading-${index}`}
              loading={isSending}
              name="Guardando..."
            ></ButtonLoading>
          ) : (
            <Button
              disabled={isSending}
              key={`button-${index}-${btn.label}`}
              onClick={
                btn.primaryAction
                  ? handleSubmit(btn.primaryAction)
                  : btn.secondaryAction
              }
              variant={
                index === step.actionButtons.length - 1 ? 'default' : 'outline'
              }
            >
              {btn.label}
            </Button>
          )
        )}
      </div>
    </>
  )
}
